import { useQuery, UseQueryOptions } from 'react-query';

import type { Playlist } from '@24i/nxg-sdk-photon';
import { usePurchaseData } from '@24i/nxg-sdk-smartott-shared/src/context/PurchaseData';

import { queryKeys } from '../queryKeys';

const useMyPurchasesQuery = (options?: UseQueryOptions<Playlist>) => {
    const { fetchMyPurchases } = usePurchaseData();

    return useQuery<Playlist>(queryKeys.myPurchases, fetchMyPurchases, {
        ...options,
    });
};

export default useMyPurchasesQuery;
